import { useState } from 'react';
import { Cooperative } from 'models';
import CooperativePickerOutput from './cooperative-picker-output';
import CooperativePickerList from './cooperative-picker-list';
import Popover from '@material-ui/core/Popover';

import { useStyles } from './style';

interface Props {
  currentCooperative: Cooperative | undefined;
  cooperatives: Cooperative[];
  handleChangeCurrentCooperative: (id: string) => void;
}

const CooperativePicker: React.FC<Props> = ({
  currentCooperative,
  cooperatives,
  handleChangeCurrentCooperative,
}) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleOpenPicker = (e: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(e.currentTarget);
  };

  const handleClosePicker = () => {
    setAnchorEl(null);
  };

  const handleChange = (id: string) => {
    handleChangeCurrentCooperative(id);
    handleClosePicker();
  };

  if (!currentCooperative) return null;

  return (
    <>
      <CooperativePickerOutput
        cooperative={currentCooperative}
        handleOpen={handleOpenPicker}
      />
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClosePicker}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transitionDuration={250}
        classes={{
          paper: classes.paper,
        }}
      >
        <CooperativePickerList
          activeId={currentCooperative.Id}
          cooperatives={cooperatives}
          handleChange={handleChange}
        />
      </Popover>
    </>
  );
};

export default CooperativePicker;
